import React from "react";
import { Link } from "react-router-dom";
import CTA from "../components/cta";
function Careers()
{
    return(
     <>
  <section
    className="flat-title-page mrg-0 brdgm boder-r-0 "
    style={{
      backgroundImage:
        "url(./images/img/banner-innerpages.jpg)",
      margin: 0
    }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Careers</h1>
        <ul className="breadcrumb">
          <li>
            <a href="./" className="text-white">
              Home
            </a>
          </li>
          <li className="text-white">/Careers</li>
        </ul>
      </div>
    </div>
  </section>
  <section
    className="flat-section flat-recommended relative-p area-detals"
    style={{ backgroundColor: "#f8f8f8" }}
  >
    <div className="container">
      <div className="row align-center">
        <div className="col-md-6">
          <div className="contact-content" style={{ padding: 0 }}>
            <h5 className="mb-15">Apply Now</h5>
            <form id="careerfrm" className="form-contact">
              <div className="mb-15">
                <fieldset>
                  <label htmlFor="name" className="mt-12">
                    Full Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your name"
                    name="cf_namec"
                    id="cf_namec"
                    required=""
                  />
                </fieldset>
                <fieldset>
                  <label htmlFor="name" className="mt-12">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Number"
                    name="cf_phone"
                    id="cf_phone"
                    required=""
                  />
                </fieldset>
                <fieldset>
                  <label htmlFor="email" className="mt-12">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name="cf_emailc"
                    id="cf_emailc"
                    required=""
                  />
                </fieldset>
                <fieldset>
                  <label htmlFor="email" className="mt-12">
                    Your Message
                  </label>
                  <textarea
                    name="cf_message"
                    className="form-control"
                    cols={30}
                    rows={10}
                    placeholder="Message"
                    id="cf_message"
                    required=""
                    defaultValue={""}
                  />
                </fieldset>
              </div>
              <div className="mb-15">
                <fieldset>
                  <div className="form-group mt-3">
                    <div className="uplod-box">
                      <label className="mr-4">Upload your CV:</label>
                      <input
                        type="file"
                        name="filenm"
                        id="filenm"
                        className="form-control"
                      />
                    </div>
                  </div>
                </fieldset>
              </div>
              <div id="responsecareer" />
              <div className="send-wrap">
                <button
                  className="tf-btn-1 primary size-1"
                  type="submit"
                  id="Submit1"
                  fdprocessedid="7kssb"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="col-md-6">
          <img
            src="./images/img/teams.jpg"
            className="brd-r"
          />
        </div>
      </div>
    </div>
  </section>
  <CTA/>
</>

    )
}
    export default Careers;